module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.dataReady) ? _c('div', {
    staticClass: "mt4 black"
  }, [_c('input', {
    staticClass: "normal",
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": _vm.twoYearsUpfront
    },
    on: {
      "change": function (event) { return _vm.setTwoYearsUpfront(event.target.checked); }
    }
  }), _vm._v(" "), _c('b', [_c('strong', [_vm._v("Pay 2 years upfront and save $" + _vm._s(_vm.twoYearDiscount) + " more!")])]), _vm._v(" "), _c('br'), _c('br')]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ef8b1b74","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/registration-v2/TwoYearUpfrontCheckbox.vue
// module id = 550
// module chunks = 0